/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProxyChallengeOptions
 */
export interface ProxyChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof ProxyChallengeOptions
     */
    challenge_id?: string;
}

/**
 * Check if a given object implements the ProxyChallengeOptions interface.
 */
export function instanceOfProxyChallengeOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProxyChallengeOptionsFromJSON(json: any): ProxyChallengeOptions {
    return ProxyChallengeOptionsFromJSONTyped(json, false);
}

export function ProxyChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxyChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge_id': !exists(json, 'challenge_id') ? undefined : json['challenge_id'],
    };
}

export function ProxyChallengeOptionsToJSON(value?: ProxyChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge_id': value.challenge_id,
    };
}

